import { useEffect } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

export const usePlayerEvent = (player, event, eventListener) => {
  useEffect(() => {
    player?.on(event, eventListener);
    return () => player?.off(event, eventListener);
  }, [player, event, eventListener]);
};